import { useCallback } from 'react';

import type { IdSalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api/types';
import { generatePath, useNavigate } from '@/js/libs/router';

import type { PromotionPage } from '../promotionPage.ts';
import { DEFAULT_PROMOTION_PAGE } from '../promotionPage.ts';

type PromotionsRoutes = {
  goToPromotionPage: (promotionId: IdSalesPromotionDto, page?: PromotionPage) => void;
  goToEditPromotion: (promotionId: IdSalesPromotionDto) => void;
  goToCreateSalesPromotion: () => void;
  goToAddPromotionAccounts: (promotionId: IdSalesPromotionDto) => void;
  goToAddPromotionContacts: (promotionId: IdSalesPromotionDto) => void;
  goToEditPromotionTemplate: (promotionId: IdSalesPromotionDto) => void;
};

export const usePromotionsRoutes = (): PromotionsRoutes => {
  const navigate = useNavigate();

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToPromotionPage = useCallback(
    (promotionId: IdSalesPromotionDto, page: PromotionPage = DEFAULT_PROMOTION_PAGE) => {
      const path = generatePath('/sales/promotions/:promotionId/:page', {
        page,
        promotionId: promotionId.toString(),
      });
      navigate(path);
    },
    [navigate],
  );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToEditPromotionTemplate = useCallback(
    (promotionId: IdSalesPromotionDto) => {
      const path = generatePath('/sales/promotions/:promotionId/mailTemplate', {
        promotionId: promotionId.toString(),
      });
      navigate(path);
    },
    [navigate],
  );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToEditPromotion = useCallback(
    (promotionId: IdSalesPromotionDto) => {
      const path = generatePath('/sales/promotions/:promotionId/edit', { promotionId: promotionId.toString() });
      navigate(path);
    },
    [navigate],
  );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToAddPromotionAccounts = useCallback(
    (promotionId: IdSalesPromotionDto) => {
      const path = generatePath('/sales/promotions/:promotionId/accounts/add', { promotionId: promotionId.toString() });
      navigate(path);
    },
    [navigate],
  );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToAddPromotionContacts = useCallback(
    (promotionId: IdSalesPromotionDto) => {
      const path = generatePath('/sales/promotions/:promotionId/contacts/add', { promotionId: promotionId.toString() });
      navigate(path);
    },
    [navigate],
  );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const goToCreateSalesPromotion = useCallback(() => navigate('/sales/promotions/new'), [navigate]);

  return {
    goToPromotionPage,
    goToCreateSalesPromotion,
    goToEditPromotion,
    goToAddPromotionAccounts,
    goToAddPromotionContacts,
    goToEditPromotionTemplate,
  };
};
